import { SolutionOutlined } from '@ant-design/icons'

import { RouteItem } from '@eastcoal/router/types/route'

import { APPLY_LIST_PAGE_PATH } from './constants/path'

export const applyRoute: RouteItem = {
  title: '邀约/报名',
  path: APPLY_LIST_PAGE_PATH,
  icon: <SolutionOutlined />,
  Component: () => import('./index')
}
